<template>
  <div class="product-form__input-wrap">
    <div class="product-form__title">{{ label }}</div>
    <Editor :object="object" :fieldName="fieldName"></Editor>
  </div>
</template>
<script>
import Editor from "../Editor.vue";

export default {
  data() {
    return {};
  },
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    object: {
      type: Object,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
  components: {
    Editor,
  },
};
</script>
